import { render, staticRenderFns } from "./layout-plain.vue?vue&type=template&id=03bdcb33&scoped=true&"
import script from "./layout-plain.vue?vue&type=script&lang=js&"
export * from "./layout-plain.vue?vue&type=script&lang=js&"
import style0 from "./layout-plain.vue?vue&type=style&index=0&id=03bdcb33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdcb33",
  null
  
)

export default component.exports